module.exports = __webpack_public_path__ + "static/media/0071_Medium.5eef9b98.jpg";